import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ModalModule } from '@osapp/modules/modal';
import { RecentsModule } from '@osapp/modules/preferences/recents/recents.module';
import { SelectorModule } from '@osapp/modules/selector/selector.module';
import { SceService } from './services/sce.service';

@NgModule({
	declarations: [],
	exports: [],
	imports: [
		CommonModule,
		ModalModule,
		IonicModule,
		RecentsModule.forRoot({ limit: 1 }),
		SelectorModule
	],
	providers: [SceService]
})
export class SceModule { }
